import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getBread } from 'reducks/bread/selectors'
import { fetchBread } from 'reducks/bread/operations'
import { Layout } from 'components/Layout'
import { DeliveryScheduleEditTemplate } from 'components/Templates'
import { BreadType } from 'types/bread'
import { getBreadShortName } from 'lib/helper'

const DeliveryScheduleEdit: FC = () => {
  const dispatch = useDispatch()
  const path = useSelector((state: State) => state.router.location.pathname)
  // ブラウザバックしたときに異なるパスでbreadIdを判定してfetchすることを防ぐ
  const paths = /^\/schedule\/delivery\/.+$/.test(path) ? path.split('/') : []
  const breadId = paths.length > 0 ? paths[paths.length - 1] : undefined
  const bread: BreadType = useSelector((state: State) => getBread(state))
  useEffect(() => {
    if (!breadId || breadId === '') return
    dispatch(fetchBread(breadId))
  }, [breadId])
  if (!bread) return <></>
  return (
    <Layout title={`${getBreadShortName(bread)}のお届け可能日を編集する`}>
      <DeliveryScheduleEditTemplate bread={bread} />
    </Layout>
  )
}

export default DeliveryScheduleEdit
